/* Level-System 2.0 — the curve lives in ONE place (@/lib/levels).
   Old flat 60-XP levels are gone; these re-exports keep every consumer
   (Profile, Dashboard, TopBar, …) on the new multi-year curve. */
import { getLevel, getLevelProgress, getLevelSpan } from "@/lib/levels";
export { getLevel, getLevelProgress };

/* ── Radial ring variant for hero sections ─────────────────────────────────── */
export function XPRing({ xp, size = 96 }) {
  const level = getLevel(xp);
  const pct   = getLevelProgress(xp);
  const r     = (size / 2) - 6;
  const circ  = 2 * Math.PI * r;
  const dash  = (pct / 100) * circ;

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="absolute inset-0 -rotate-90"
        style={{ filter: "drop-shadow(0 0 6px rgba(139,92,246,0.5))" }}
      >
        {/* Track */}
        <circle
          cx={size / 2} cy={size / 2} r={r}
          fill="none"
          stroke="rgba(139,92,246,0.12)"
          strokeWidth="5"
        />
        {/* Progress */}
        <circle
          cx={size / 2} cy={size / 2} r={r}
          fill="none"
          stroke="url(#xp-ring-grad)"
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circ}`}
          style={{ transition: "stroke-dasharray 1s cubic-bezier(0.22,1,0.36,1)" }}
        />
        <defs>
          <linearGradient id="xp-ring-grad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   stopColor="#06b6d4" />
            <stop offset="50%"  stopColor="#8b5cf6" />
            <stop offset="100%" stopColor="#ec4899" />
          </linearGradient>
        </defs>
      </svg>
      <div className="text-center z-10">
        <p className="text-xs font-black text-violet-400 leading-none">Lv.</p>
        <p className="text-xl font-black text-white leading-tight">{level}</p>
      </div>
    </div>
  );
}

/* ── Standard horizontal bar ───────────────────────────────────────────────── */
export default function XPBar({ xp, size = "md", showLabel = true }) {
  const level = getLevel(xp);
  const pct   = getLevelProgress(xp);
  const h     = size === "sm" ? "h-1.5" : size === "lg" ? "h-4" : "h-2.5";
  const span  = getLevelSpan(xp);

  return (
    <div className="w-full">
      {showLabel && (
        <div className="flex justify-between mb-1.5 text-[11px] font-bold">
          <span className="text-gray-400">Level {level}</span>
          <span className="text-violet-400">
            {level >= 100 ? "MAX — Legende" : `${span.current.toLocaleString("de-AT")} / ${span.needed.toLocaleString("de-AT")} XP → Lv.${level + 1}`}
          </span>
        </div>
      )}
      <div
        className={`w-full ${h} rounded-full overflow-hidden`}
        style={{ background: "rgba(139,92,246,0.1)", boxShadow: "inset 0 1px 3px rgba(0,0,0,0.3)" }}
      >
        <div
          className={`${h} xp-bar rounded-full transition-all duration-1000`}
          style={{
            width: `${pct}%`,
            boxShadow: "0 0 12px rgba(139,92,246,0.7), 0 0 4px rgba(6,182,212,0.5)",
            minWidth: pct > 0 ? "4px" : "0",
          }}
        />
      </div>
    </div>
  );
}
